"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectDriversItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectDriversItem, _Component);

  function ProjectDriversItem(props) {
    (0, _classCallCheck3.default)(this, ProjectDriversItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectDriversItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectDriversItem)).call(this, props));

    _this.removeItem = function (event) {
      event.preventDefault();
      _this.props.removeProjectDriver(_this.props.item);
    };

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.updateQuantity = _this.updateQuantity.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);

    _this.state = {
      is_active: false
    };
    return _this;
  }

  (0, _createClass3.default)(ProjectDriversItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var item = this.props.item;

      this.setState({
        is_active: item.is_active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var item = this.props.item;
      var quantity = this.state.quantity;


      return _react2.default.createElement(
        "tr",
        { className: "project-user-item", key: item.id },
        _react2.default.createElement(
          "td",
          { className: "project-user-checkbox" },
          _react2.default.createElement(
            "div",
            { className: "checkbox-single" },
            _react2.default.createElement("input", {
              name: "is_active",
              type: "checkbox",
              checked: this.state.is_active,
              onChange: this.handleInputChange })
          )
        ),
        _react2.default.createElement(
          "td",
          { className: "cart-item-price" },
          item.email
        )
      );
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(event) {
      event.preventDefault();
      this.setState({ quantity: event.target.value });
    }
  }, {
    key: "removeProjectDriver",
    value: function removeProjectDriver() {}
  }, {
    key: "updateByEmail",
    value: function updateByEmail(data) {
      var updateProjectDriverByEmail = this.props.updateProjectDriverByEmail;

      var tempData = data;
      tempData.project_id = this.props.projectId;
      updateProjectDriverByEmail(tempData);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === "checkbox" ? target.checked : target.value;
      var name = target.name;
      this.setState((0, _defineProperty3.default)({}, name, value));

      var newData = this.props.item;
      newData[target.name] = target.checked;
      this.updateByEmail(newData);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      event.preventDefault();
      var quantity = parseInt(event.target.value, 10);
      if (isNaN(quantity) || quantity <= 0) {
        quantity = 1;
      }
      this.setState({ quantity: quantity });
      this.props.updateQuantity(this.props.item, quantity);
    }
  }]);
  return ProjectDriversItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object.isRequired,
  updateProjectDriverByEmail: _react.PropTypes.func.isRequired

}, _temp);
exports.default = ProjectDriversItem;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectDriversItem.js
 ** module id = 1174
 ** module chunks = 0
 **/